module.exports = __webpack_public_path__ + "static/SpeechLanguageReport-bc60c41514c021480b29f1728cbc4c34.pdf";